var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row inline q-py-md" }, [
        _c(
          "div",
          { staticClass: "col" },
          _vm._l(_vm.groupedSpeciesList, function(group) {
            return _c("q-btn", {
              key: group.letter,
              attrs: { label: group.letter, flat: "" },
              on: {
                click: function($event) {
                  return _vm.jumpToGalleryAnchor(
                    "#gallery-jump-anchor-" + group.letter
                  )
                }
              }
            })
          }),
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "q-list",
        { attrs: { dense: "" } },
        _vm._l(_vm.groupedSpeciesList, function(group) {
          return _c(
            "div",
            {
              key: group.name,
              attrs: { id: "gallery-jump-anchor-" + group.letter }
            },
            _vm._l(group.groups, function(category) {
              return _c(
                "q-item-section",
                { key: category.name, attrs: { top: "" } },
                [
                  category.species.length > 1
                    ? [
                        _c("q-item-label", { attrs: { header: "" } }, [
                          _vm._v(_vm._s(category.name))
                        ]),
                        _vm._v(" "),
                        _vm._l(category.species, function(species) {
                          return _c(
                            "q-item",
                            {
                              key: species.uid,
                              attrs: {
                                "inset-level": 1,
                                clickable: "",
                                dense: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.newSpeciesLogSearch(species)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.getDisplayName(species)) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          )
                        })
                      ]
                    : [
                        _c(
                          "q-item",
                          {
                            staticClass: "text-bold",
                            attrs: {
                              "inset-level": 0,
                              clickable: "",
                              dense: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.newSpeciesLogSearch(
                                  category.species[0]
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.getDisplayName(category.species[0])
                                ) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      ]
                ],
                2
              )
            }),
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }